import { SvcModalActionPlanStatusTypeById } from '@solvace/feature/modals/svc-modal-action-plan/shared/enums/svc-modal-action-plan-status.enum';

export type ActionPlanBadgeType = 'late' | 'approval' | 'completed' | 'inactive' | 'ontime';

export function resolveStatusBadgeType(statusId: number | null | undefined): ActionPlanBadgeType {
  if (statusId == null) return 'inactive';
  const mapped = SvcModalActionPlanStatusTypeById[statusId];
  return mapped ?? 'ontime';
}

const STATUS_PILL_CLASS: Record<ActionPlanBadgeType, string> = {
  late: 'border-[#EC221F] bg-[#FDE7E7] text-[#EC221F]',
  ontime: 'border-[#A07D12] bg-[#FDF3D6] text-[#A07D12]',
  approval: 'border-[#001391] bg-[#F5F5FF] text-[#001391]',
  completed: 'border-[#14AE5C] bg-[#DCF5E6] text-[#14AE5C]',
  inactive: 'border-[#71767C] bg-[#EEF0F2] text-[#71767C]',
};

export function resolveStatusPillClass(statusId: number | null | undefined): string {
  return STATUS_PILL_CLASS[resolveStatusBadgeType(statusId)];
}
